import React, { useEffect, createRef } from 'react';
import { useDispatch } from 'react-redux';
import { getTranslator } from '../../Translator';
import { RenderErrors } from '../ui/ErrorComponent';
import { SidePanel } from '../ui/SidePanel';
import { editNextPartyName, makeNextParty, newPartyListOrderSet, nextPartyCodeSet, createPartySidePanelToggled } from '../../features/election/electionScreenSlice';
import { useAppSelector } from '../../hooks';

type CreatePartyPaneProps = {
    visible: boolean;
    electionId: number;
    candidacyMode: boolean;
}

export const CreatePartyPane = (props: CreatePartyPaneProps) => {
    const language = useAppSelector(state => state.language);
    const parties = useAppSelector(state => state.parties);
    const token = useAppSelector(state => state.clientState.RequestVerificationToken);

    const t = getTranslator(language);
    const electionScreenState = useAppSelector(state => state.electionScreen);
    const dispatch = useDispatch();
    const hasDistributionOfSeats = useAppSelector(state => state.clientState.HasDistributionOfSeats);
    const justDutch = useAppSelector(state => state.clientState.JustDutch);

    useEffect(() => {
        if (props.visible) {
            setFocusOnNameNl();
        }
    }, [props.visible])

    const nameNlInputRef = createRef<HTMLInputElement>();

    const setFocusOnNameNl = () => {
        nameNlInputRef && nameNlInputRef.current && nameNlInputRef.current.focus();
    }
    return <SidePanel visible={props.visible} toggleAction={() => dispatch(createPartySidePanelToggled())}>
        <h1>{t['Add Parties']}</h1>
        <form className="editor" onSubmit={e => e.preventDefault()}>
            <label>
                {t['Name (NL)']}
                <input type="text" lang="nl-NL" value={electionScreenState.nextName.NL} onChange={e => editNextPartyName({ NL: e.target.value }, electionScreenState, parties, dispatch)} ref={nameNlInputRef} />
            </label>
            {!justDutch && <label>
                {t['Name (EN)']}
                <input type="text" lang="en-GB" value={electionScreenState.nextName.EN} onChange={e => editNextPartyName({ EN: e.target.value }, electionScreenState, parties, dispatch)} />
            </label>}
            <label>
                {t['Party code']}
                <input value={electionScreenState.nextCode} onChange={e => dispatch(nextPartyCodeSet({ code: e.target.value, isManual: true }))} />
            </label>
            <label>
                <input type="radio" checked={electionScreenState.nextListOrder} onChange={e => dispatch(newPartyListOrderSet(e.target.checked))} />
                {t['List order']}
            </label>
            {hasDistributionOfSeats && <label>
                <input type="radio" checked={!electionScreenState.nextListOrder} onChange={e => dispatch(newPartyListOrderSet(!e.target.checked))} />
                {t['Majority of votes']}
            </label>}
            <div className="buttonrow">
                <button onClick={() => makeNextParty(props.electionId, electionScreenState, parties, token, dispatch).then(gelukt => gelukt && props.candidacyMode ? dispatch(createPartySidePanelToggled()) : setFocusOnNameNl())}>{t['Create']}</button>
            </div>
        </form>
        <div className="home__error">
            <RenderErrors errors={electionScreenState.errors} />
        </div>
        {props.candidacyMode && <div className="home__warning">{
            t.translate({
                NL: 'Vergeet niet om na het toevoegen van je partij, ook nog eventueel jezelf en anderen als kandidaat toe te voegen. Ook als je de enige kandidaat bent, moet je jezelf als kandidaat aan je partij toevoegen. Klik hiervoor op je aangemaakte partij en vervolgens op "Kandidaten toevoegen". Zie voor meer uitleg ook de helpteksten onder de vraagtekenicoontjes.',
                EN: 'After adding your party, do not forget to add yourself and others as candidates. Even if you are the only candidate, you must add yourself to your party as a candidate. For more explanation, see also the help texts under the question mark icons.'
            })}</div>
        }

    </SidePanel>
}
